import React from 'react';

function Divider({ hidden }) {

    return (
        <span className={`divider${hidden ? ' hidden' : ''}`}>·</span>
    );
}

function Footer() {
    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        © {(new Date()).getFullYear()} CommentBox.io <Divider/> <a target="_blank" href="https://commentbox.io/privacy">Privacy</a> <Divider/> <a target="_blank" href="https://commentbox.io/terms">Terms</a>
                    </div>
                    <div className="right col-lg-6 col-md-6 col-sm-6 hidden-xs">
                        <a target="_blank" href="https://twitter.com/commentbox_io">
                            @commentbox_io
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/_global/Footer.jsx